import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import '../node_modules/toastr/build/toastr.min.css';
import App from './App';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);


